const DashboardFavouriteIcon = (props) => (
  <svg
    width={21}
    height={19}
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 19C10.1972 19 9.90419 18.9606 9.66 18.872C5.92884 17.5824 0 13.0047 0 6.24145C0 2.79585 2.76419 0 6.16326 0C7.81395 0 9.35721 0.649741 10.5 1.8114C11.6428 0.649741 13.186 0 14.8367 0C18.2358 0 21 2.8057 21 6.24145C21 13.0145 15.0712 17.5824 11.34 18.872C11.0958 18.9606 10.8028 19 10.5 19ZM6.16326 1.47668C3.57488 1.47668 1.46512 3.61295 1.46512 6.24145C1.46512 12.9653 7.88233 16.7062 10.1386 17.4839C10.3144 17.543 10.6953 17.543 10.8712 17.4839C13.1177 16.7062 19.5447 12.9751 19.5447 6.24145C19.5447 3.61295 17.4349 1.47668 14.8465 1.47668C13.3619 1.47668 11.9847 2.17565 11.0958 3.38653C10.8223 3.76062 10.1972 3.76062 9.92372 3.38653C9.01535 2.1658 7.64791 1.47668 6.16326 1.47668Z"
      fill="currentColor"
    />
  </svg>
);
export default DashboardFavouriteIcon;
